<template>
  <div class="modal-body">
    <div style="position: relative">
      <el-page-header
        @back="goBack"
        content="培训成绩分布汇总"
      ></el-page-header>
      <div class="btn" @click="isShow = !isShow">
        <!-- <el-button type="primary" size="mini" icon="">
          <slot name="icon"><img class="icon_style" src="../../assets/imgs/report/shaixuan.png"/></slot>
        </el-button> -->
        <i
          size="mini"
          class="filter_style"
          style="color: #fff"
          :class="isShow == false ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
          ><span>筛选</span></i
        >
      </div>
    </div>
    <div
      style="width: 100%; overflow: auto"
      :style="{ height: height + 'px' }"
      v-loading="chartLoading"
    >
      <div class="option" v-show="isShow">
        <el-form
          class="form-style"
          ref="params"
          :model="params"
          size="mini"
          label-width="70px"
        >
          <el-form-item label="开始日期" prop="BeginDate">
            <el-date-picker
              style="width: 120px"
              @change="
                (val) => {
                  changeBeginDate(val);
                }
              "
              v-model="BeginTime"
              type="month"
              format="yyyy年MM月"
              value-format="yyyy-MM"
              placeholder="开始日期"
              clearable
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="结束日期" prop="EndDate">
            <el-date-picker
              style="width: 120px"
              @change="
                (val) => {
                  changeEndDate(val);
                }
              "
              v-model="EndTime"
              type="month"
              format="yyyy年MM月"
              value-format="yyyy-MM"
              placeholder="结束日期"
              clearable
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="事业部" prop="College">
            <el-select
              v-model="params.College"
              placeholder="请选择事业部"
              style="width: 120px"
              @change="selectProject"
              clearable
            >
              <el-option
                v-for="item in Colleges"
                :key="item.Id"
                :label="item.Name"
                :value="item.Id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="分线" prop="Branch">
            <el-select
              v-model="params.Branch"
              placeholder="请选择分线"
              style="width: 120px"
              @change="getQuery"
              clearable
            >
              <el-option
                v-for="item in productLine"
                :key="item.Id"
                :label="item.Name"
                :value="item.Id"
              ></el-option>
            </el-select>
          </el-form-item>

          <!-- <el-form-item label="课程" prop="CourseId">
          <el-cascader popper-class="cascader_box_Id" style="width: 120px;" v-model="params.courseId" :options="course_options" 
            :props="cascaderProps" size="mini" :show-all-levels="false" :change-on-select='false'
            filterable placeholder="选择课程">
          </el-cascader>
        </el-form-item> -->

          <!-- <el-form-item label-width="0px">
          <div style="text-align: center;margin-top: 30px;">
            <el-button size="medium" type="primary" :loading="loadingsave" @click="saveplans">确认</el-button>
          </div>

        </el-form-item> -->
        </el-form>
      </div>
      <div id="main1" style="width: 100%; min-height: 500px"></div>
      <!-- <div id="main2" style="width:100%;min-height:240px"></div> -->
      <div id="main3" style="width: 100%; min-height: 240px"></div>
    </div>

    <el-drawer title="筛选" :visible.sync="showDialog" @close="close">
    </el-drawer>
  </div>
</template>
<script>
import {
  getBaseUrl,
  GetFenLeiList,
  GetProjectList,
  AllCourseCascaderOption,
  GetTrainScoreKpi,
} from "../../api/api";
import moment, { min } from "moment";
import echarts from "echarts";

export default {
  data() {
    return {
      baseUrl: getBaseUrl(),
      chartLoading: false,
      height: 0,
      loading: false,
      loadingsave: false,
      date: "2021年1月",
      Colleges: [], // 事业部
      productLine: [], //产品线
      relationProject: [], //项目
      course_options: [], //课程
      showDialog: false,
      isShow: false,
      dataList: [],
      seriesList: [],
      DsTrainTypeList: [],
      DsRegionList: [],
      proportion2: [],
      // searchModel:{
      //   StartTime:'',
      //   EndTime:'',
      //   SybId:'',
      //   CpxId:'',
      //   Type:'',
      //   ProjectId:'',
      //   courseId:'',
      // },
      BeginTime: "",
      EndTime: "",
      params: {
        TrainerId: 0,
        BeginDate: "",
        EndDate: "",
        College: "",
        Branch: "",
        CourseId: 0,
        SearchKey: "",
      },
      cascaderProps: {
        label: "Name",
        value: "KeyStr",
        children: "Children",
        emitPath: false,
        // checkStrictly:true
      },
      colors: [
        ["#4a7fb0", "#adc6e5", "#96bfee", "#60a0e8", "#96bfee", "#c6ccd4"],
        ["#4a7fb0", "#adc6e5", "#96bfee", "#60a0e8", "#96bfee", "#c6ccd4"],
        ["#2f75b5", "#348bee", "#96bfee", "#60a0e8", "#96bfee", "#c6ccd4"],
      ],
      // ['85-100', '75-84', '60-74','60分以下']
      // score1:[{value:80,name:'85-100'},{value:60,name:'75-84'},{value:70,name:'60-74'},
      // {value:30,name:'60分以下'}],
      // score2:[{value:70,name:'85-100'},{value:85,name:'75-84'},{value:53,name:'60-74'},
      // {value:42,name:'60分以下'}],
    };
  },
  mounted() {
    this.height = window.innerHeight - 80;
    this.GetFenLeiList();
    //  this.getCourse();
    this.search();
  },
  methods: {
    search() {
      this.chartLoading = true;
      GetTrainScoreKpi(this.params).then((res) => {
        if (res.data.Code != 1) return;
        // if(res.data.Data.length==0)
        // {
        //   this.chartLoading = false;
        //   return this.$message.error('无匹配数据！');
        // }
        this.dataList = res.data.Data;
        this.seriesList = [];
        this.DsTrainTypeList = [];
        this.DsRegionList = [];
        this.proportion2 = [];
        // this.score1 = DsTrainTypeList;
        this.dataList.forEach((e) => {
          if (this.DsTrainTypeList.indexOf(e.TrainType) < 0) {
            this.DsTrainTypeList.push(e.TrainType);
          }
          if (this.DsRegionList.indexOf(e.Region) < 0) {
            this.DsRegionList.push(e.Region);
          }
          //this.seriesList.push({name:e.TrainType,type: "bar",data:[e.Value],label:{show:true}})
        });
        this.DsTrainTypeList.forEach((e) => {
          var arrDt = new Array(this.DsRegionList.length);
          var iCounts = 0;
          this.dataList.forEach((k) => {
            if (k.TrainType == e) {
              arrDt[this.DsRegionList.indexOf(k.Region)] = k.Value;
              iCounts += k.Value;
            }
          });
          this.seriesList.push({
            name: e,
            type: "bar",
            data: arrDt,
            stack: "1",
            barGap: "-100%",
            label: { show: true },
          });
          this.proportion2.push({ value: iCounts, name: e });
        });
        setTimeout(() => {
          this.initChart();
          this.myChart3();
          // this.myChart2();

          this.chartLoading = false;
        }, 100);
      });
    },

    initChart() {
      // 基于准备好的dom，初始化echarts实例
      var myChart = echarts.init(document.getElementById("main1"));
      var option = {
        color: this.colors[0],
        backgroundColor: "transparent", //#344b58
        title: {
          text: "培训合格率汇总",
          top: 15,
          left: "center",
          textStyle: {
            color: "#000",
            fontSize: "16",
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
            textStyle: {
              color: "#fff",
            },
          },
        },
        grid: {
          borderWidth: 0,
          top: "24%",
          left: 10,
          width: "94%",
          textStyle: {
            color: "#fff",
          },
          containLabel: true,
        },
        legend: {
          left: "8%",
          top: "12%",
          textStyle: {
            color: "#90979c",
          },
          // data: ['85-100', '75-84', '60-74','60分以下']
          data: this.DsTrainTypeList,
        },
        calculable: true,
        xAxis: [
          {
            type: "category",
            // data: ['12','1','2','3','4','5','6','7','8','9','10','11','12'],
            data: this.DsRegionList,
            axisPointer: {
              type: "shadow",
            },
            axisLabel: {
              formatter: function (value) {
                return 1 * value.substring(value.length - 2);
              },
            },
            min: 8,
          },
        ],
        yAxis: {
          type: "value",
          name: "人数",
          min: 0,
          axisLabel: {
            formatter: "{value}",
          },
        },
        dataZoom: [
          {
            show: true,
            height: 30,
            xAxisIndex: [0],
            bottom: 10,
            start: 1,
            end: 100,
            handleIcon:
              "path://M306.1,413c0,2.2-1.8,4-4,4h-59.8c-2.2,0-4-1.8-4-4V200.8c0-2.2,1.8-4,4-4h59.8c2.2,0,4,1.8,4,4V413z",
            handleSize: "110%",
            handleStyle: {
              color: "#d3dee5",
            },
            textStyle: { color: "#fff" },
            borderColor: "#90979c",
          },
          {
            type: "inside",
            show: true,
            height: 15,
            start: 1,
            end: 35,
          },
        ],
        series: this.seriesList,
      };
      myChart.setOption(option);
    },

    myChart2() {
      var myChart2 = echarts.init(document.getElementById("main2"));
      var option = {
        color: this.colors[1],
        title: {
          left: "center",
          top: 10,
          bottom: "10%",
          text: "YTD合格分数分布",
          textStyle: {
            color: "#000",
            fontSize: 16,
          },
        },
        label: {
          normal: {
            formatter: "{c}",
            position: "inside",
          },
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c}",
        },
        legend: {
          orient: "vertical",
          left: 20,
          top: "15%",
        },
        series: [
          {
            name: "YTD合格分数分布: ",
            type: "pie",
            top: 40,
            left: "10%",
            radius: "70%",
            labelLine: {
              show: false,
            },
            label: {
              position: "inner",
              show: true,
              // formatter:'{b} : \n{d}%',
              formatter: " \n{d}%",
              fontSize: 12,
            },
            // data: this.score1,
            data: this.DsTrainTypeList,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      myChart2.setOption(option);
    },
    myChart3() {
      var myChart3 = echarts.init(document.getElementById("main3"));
      var option = {
        color: this.colors[2],
        title: {
          left: "center",
          top: 10,
          bottom: "10%",
          text: "总累计合格分数分布",
          textStyle: {
            color: "#000",
            fontSize: 16,
          },
        },
        label: {
          normal: {
            formatter: "{c}",
            position: "inside",
          },
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c}",
        },
        legend: {
          orient: "vertical",
          left: 20,
          top: "15%",
        },
        series: [
          {
            name: "总累计合格率: ",
            type: "pie",
            top: 40,
            left: "10%",
            radius: "70%",
            labelLine: {
              show: false,
            },
            label: {
              position: "inner",
              show: true,
              formatter: "\n{d}%",
              // formatter:'{b} : \n{d}%',
              fontSize: 12,
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
            // data: this.score2,
            data: this.proportion2,
          },
        ],
      };
      myChart3.setOption(option);
    },

    showSearch() {
      this.showDialog = true;
      this.GetFenLeiList();
      // this.getMainProgect();
      this.getCourse();
    },
    // 事业部
    GetFenLeiList() {
      GetFenLeiList(-1).then((res) => {
        if (res.data.Code != 1) return;
        this.Colleges = res.data.Data;
      });
    },
    selectProject(val) {
      this.params.College = "";
      this.productLine = [];
      this.Colleges.forEach((e) => {
        if (e.Id == val) {
          this.params.College = e.Name;
        }
      });
      GetFenLeiList(val).then((res) => {
        if (res.data.Code != 1) return;
        this.productLine = res.data.Data;
      });
      this.params.Branch = "";
      this.search();
    },
    getQuery(val) {
      // this.params.College = ''
      this.search();
    },
    getCourse() {
      AllCourseCascaderOption().then((res) => {
        this.course_options = res.data.Data;
      });
    },

    // changeBeginDate(val){
    //   var endTime = this.params.EndDate;
    //   if(val){
    //           var start = moment(new Date(val)).format("YYYY-MM"); //开始时间
    //   var end = moment(new Date(endTime)).format("YYYY-MM"); //结束时间
    //   console.log(val,start,'start')
    //   if(start>end){
    //     this.$message.error('开始日期不能大于结束日期');
    //     this.params.BeginDate = '';
    //     return;
    //   }
    //   }else{
    //     this.params.BeginDate = '';
    //   }
    //     this.search();
    // },
    changeBeginDate(val) {
      var endDate = this.EndTime;
      if (val) {
        var start = moment(new Date(val)).format("YYYY-MM"); //开始时间
        var end; //结束时间
        if (endDate) {
          end = moment(new Date(endDate)).format("YYYY-MM"); //结束时间
        }
        if (end && start > end) {
          this.$message.error("开始日期不能大于结束日期");
          this.params.BeginDate = "";
          return;
        }
        this.params.BeginDate = start;
        this.params.EndDate = end;
      } else {
        this.params.BeginDate = "";
      }
      this.search();
    },

    changeEndDate(val) {
      var beginDate = this.BeginTime;
      if (val) {
        var end = moment(new Date(val)).format("YYYY-MM"); //开始时间
        if (beginDate) {
          var start = moment(new Date(beginDate)).format("YYYY-MM"); //结束时间
          if (end < start) {
            this.$message.error("结束日期不能小于开始日期");
            this.params.EndDate = "";
            return;
          }
        }
        this.params.EndDate = end;
      } else {
        this.params.EndDate = "";
      }
      this.search();
    },

    // changeEndDate(val){
    //   var BeginDate = this.params.BeginDate;
    //   if(val){
    //     var end = moment(new Date(val)).format("YYYY-MM"); //开始时间
    //   var start = moment(new Date(BeginDate)).format("YYYY-MM"); //结束时间
    //   if(end<start){
    //     this.$message.error('结束日期不能小于开始日期');
    //     this.params.EndDate = '';
    //     return;
    //   }
    //   }else{
    //     this.params.BeginDate = "";
    //   }

    //   this.search();
    // },
    saveplans() {
      //   this.loadingsave = true;
      this.showDialog = false;
      this.search();
      //   api(this.searchModel).then(res=>{
      //     this.loadingsave = false;
      //     if(res.data.Code != 1) return;
      //     this.showDialog = false;
      //     this.search();
      //   })
      this.close();
    },
    close() {
      this.params = {};
    },
    goBack() {
      window.history.go(-1);
    },
  },
  watch: {},
};
</script>

<style lang="less" scoped>
html,
body {
  height: 100%;
}
.modal-body {
  overflow: hidden;
  height: 100%;
  padding: 0;
  font-size: 14px;
  font-family: "Helvetica Neue", Arial, "PingFang SC", "Hiragino Sans GB",
    "\5B8B\4F53", "Microsoft Yahei", sans-serif;
}

.el-page-header {
  height: 80px;
  background: rgb(32, 148, 244);
  // display: flex;
  align-items: flex-end;
  color: #fff;
  padding: 0 10px 10px;
  box-sizing: border-box;
}
/deep/.el-button--success {
  background: rgb(32, 148, 244);
  border: 1px solid rgb(32, 148, 244);
  background-color: rgb(32, 148, 244);
}
.btn {
  position: absolute;
  top: 44px;
  // margin-top: -14px;
  right: 5px;
  z-index: 999;
}
/deep/ .el-page-header__content {
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  // margin-left: 16%;
  width: calc(100% - 188px);
  text-align: center;
}
/deep/ .el-page-header__left::after {
  display: none;
}

/deep/ .el-drawer {
  width: 70% !important;
}

.el-cascader-panel {
  width: 375px !important;
  overflow-x: auto;
}
/deep/.el-input--suffix .el-input__inner {
  padding-right: 3px;
}
.form-style {
  display: flex;
  justify-content: center;
  align-items: center;

  flex-wrap: wrap;
  width: 100%;
  margin: 10px auto;
  /deep/.el-form-item {
    width: 50%;
    // margin-bottom: 22px;
  }
}
/deep/.el-form-item--mini.el-form-item {
  margin-left: -12px;
  margin-bottom: 7px;
}
/deep/.el-form-item__content {
  margin-left: -40px;
}
/deep/.el-form-item__label {
  padding-right: 1px;
}
</style>

<style lang='scss' >
.cascader_box_Id {
  width: 100%;
  overflow-x: auto;
  float: left;
  // background: pink;
}
.icon_style {
  width: 20px;
  height: 20px;
}
//   /deep/.el-button--mini{
//  background-color: rgb(32, 148, 244);
//  border: 1px solid rgb(32, 148, 244);
// }
.filter_style {
  margin-top: 6px;
  span {
    padding-left: 4px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/report/TrainScoreReport.vue